import { createContext, useContext } from 'react'

export type Branding = {
  appName: string
  logo?: string | null
  /** Variante du logo pour le thème sombre. Nulle = `logo` sert sur les deux fonds (#31). */
  logoDark?: string | null
  favicon?: string | null
  primaryColor?: string | null
  /** Encre choisie SUR la couleur principale. Nulle = la plus lisible est calculée (#31). */
  primaryForeground?: string | null
  accentColor?: string | null
  /** Encre choisie SUR la couleur secondaire. Même contrat que `primaryForeground`. */
  accentForeground?: string | null
  footerText?: string | null
  defaultLocale?: string | null
  /**
   * Fuseau de l'organisation (IANA). Découpe les jours des bornes de parcours :
   * toute date de session s'affiche dedans, pas dans celui du navigateur (#194).
   */
  timezone?: string | null
  /** L'admin achète lui-même sa formule (#165). Coupé tant que le paiement n'existe pas. */
  billingSelfService?: boolean | null
  /**
   * La query `appConfig` a-t-elle rendu son verdict ? Faux uniquement pendant le
   * premier aller-retour, où `appName` vaut encore le défaut. Les écrans qui
   * citent le nom au fil d'une phrase attendent ce drapeau plutôt que d'afficher
   * un nom qui se corrigera sous les yeux du lecteur (#35).
   */
  loaded: boolean
}

export const DEFAULT_BRANDING: Branding = {
  // Miroir du `@default` Prisma sur `AppConfig.appName`. Ce nom est lu tel quel
  // par l'apprenant (onglet, logo textuel, notice RGPD), donc il doit désigner
  // quelque chose : « LMS » ne voulait rien dire pour lui (#35).
  appName: 'Studeva',
  // Miroir du `DEFAULT_TIMEZONE` de l'API, le temps que la query réponde.
  timezone: 'Europe/Paris',
  billingSelfService: false,
  loaded: false,
}

export const BrandingContext = createContext<Branding>(DEFAULT_BRANDING)

/** Branding de l'organisation courante, tel que le provider l'a résolu. */
export function useBranding(): Branding {
  return useContext(BrandingContext)
}
